import { render, staticRenderFns } from "./restorePassword.vue?vue&type=template&id=ac878e86&scoped=true&"
import script from "./restorePassword.vue?vue&type=script&lang=js&"
export * from "./restorePassword.vue?vue&type=script&lang=js&"
import style0 from "./restorePassword.vue?vue&type=style&index=0&id=ac878e86&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac878e86",
  null
  
)

export default component.exports